export enum CloudUserAssociatedDomain {
  TrustedDomain = 'Trusted Domain',
  Excel = 'Excel',
  ActiveDomain = 'Active Domain',
  Catalog = 'Catalog',
  Scim = 'Scim'
}
